import React, { Fragment, useMemo, useState } from 'react';
import classnames from 'classnames';
import FilterWidgets from '@op/components/FilterCommon/widgets';
import {
  DefaultConfigType,
  FilterKeys,
  TFilterGroupKeys,
} from '@op/components/FilterCommon/types';
import { getGroupList } from '@op/components/FilterCommon/constants/group';
import { useIntl } from 'umi';
import SvgIcon from '@/pages/home/components/SvgIcon';
import './index.scss';

type TFilterPropsType = {
  filter: Array<FilterKeys>;
  filterOptions: { [key: string]: any };
  params: any;
  isTile?: boolean;
  dealwithFilterOptionsMap: {
    [key in FilterKeys]?: (options: any) => any;
  }; // 处理筛选项的函数
  defaultConfig?: DefaultConfigType;
  FilterItemClassName?: string;
  filterItemRender?: (
    filterKey: FilterKeys,
    element: JSX.Element,
  ) => JSX.Element;
  noPreviewsGroups?: TFilterGroupKeys[];
};

export function FilterTile({
  filter,
  filterOptions,
  params,
  dealwithFilterOptionsMap,
  defaultConfig,
  FilterItemClassName,
  filterItemRender,
  title,
  noPreview
}: TFilterPropsType & { title?: any; noPreview?: boolean }) {
  function getComponentsParams(key: FilterKeys) {
    // const realParams = { ...params };
    // 需要cond接口数据组件塞数据进去
    const itemOptions = filterOptions[key];
    if (itemOptions) {
      const func = dealwithFilterOptionsMap[key];
      params['filterOptions'] = func?.(itemOptions) || itemOptions;
    } else {
      // 这里重置一下，不然会使用前面过滤器的数据
      params['filterOptions'] = [];
    }

    return params;
  }

  function getRenderElementInfo(key: FilterKeys) {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    let Component = FilterWidgets[key];
    if (typeof Component !== 'function' && Component) {
      Component = Component.component;
    }

    const realParams = getComponentsParams(key);

    const userConfig = defaultConfig?.[key as 'channel'] || {};

    // eslint-disable-next-line @typescript-eslint/naming-convention
    const Element: JSX.Element = (
      <Component {...realParams} {...userConfig} defaultKey={key}></Component>
    );

    return Element;
  }

  return (
    <div className={classnames({"dbo-filter-preview-able": !noPreview})}>
      {filter.map((key: FilterKeys, index: number) => {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const Element: JSX.Element = getRenderElementInfo(key);

        return (
          <div
            className={classnames(FilterItemClassName, {
              'filter-common-item-label': index === 0,
            })}
            key={key}
          >
            {index === 0 && title}
            {filterItemRender?.(key, Element) || Element}
          </div>
        );
      })}
    </div>
  );
}

export function FilterGroups({
  filter,
  filterOptions,
  params,
  dealwithFilterOptionsMap,
  defaultConfig,
  FilterItemClassName,
  filterItemRender,
  isTile,
  noPreviewsGroups
}: TFilterPropsType) {
  const { formatMessage } = useIntl();
  const isEn = params.lang === 'en-US';
  const [renderFilterList, isMax] = useMemo(() => {
    if (isTile) {
      const list = [
        {
          text: '',
          list: filter,
          packList: [],
          packText: '',
          packIcon: '',
          isPack: false,
          value: "" as TFilterGroupKeys
        },
      ];
      return [list, false];
    }

    const { group } = defaultConfig || {};

    const { list, isMax } = getGroupList(filter, group);

    return [list.filter((item) => item !== null), isMax];
  }, [filter]);

  const [showPack, setShowPack] = useState(false);
  return (
    <div
      className={classnames('dbo-filter-groups-list', {
        max: isMax && isEn,
        medium: isMax && !isEn,
        '--is-Tile': isTile,
      })}
    >
      {renderFilterList.map(
        ({ text, list, packList, packText, packIcon, isPack, value }) => {
          const noPreview = noPreviewsGroups?.includes(value);
          return (
            <Fragment key={text}>
              <FilterTile
                filter={list}
                filterOptions={filterOptions}
                params={params}
                noPreview={noPreview}
                defaultConfig={defaultConfig}
                dealwithFilterOptionsMap={dealwithFilterOptionsMap}
                filterItemRender={filterItemRender}
                FilterItemClassName={FilterItemClassName}
                title={
                  !isTile && (
                    <div
                      className={classnames('dbo-filter-groups-title', {
                        max: isMax && isEn,
                        medium: isMax && !isEn,
                      })}
                    >
                      {formatMessage({ id: text })}
                    </div>
                  )
                }
              ></FilterTile>
              {isPack && (
                <div
                  className="dbo-filter-groups-filter-pack"
                  key={packText}
                  onClick={() => setShowPack(!showPack)}
                >
                  <img src={packIcon}></img>
                  <span>{formatMessage({ id: packText })}</span>
                  <SvgIcon
                    className={classnames({
                      'dbo-show-all': showPack,
                    })}
                    type="fill-icon-arrow"
                  />
                </div>
              )}
              {isPack && (
                <div
                  className={classnames('dbo-filter-groups-filter-pack-box', {
                    show: showPack,
                  })}
                >
                  <FilterTile
                    filter={packList}
                    filterOptions={filterOptions}
                    params={params}
                    noPreview={noPreview}
                    defaultConfig={defaultConfig}
                    FilterItemClassName={FilterItemClassName}
                    dealwithFilterOptionsMap={dealwithFilterOptionsMap}
                    filterItemRender={filterItemRender}
                  ></FilterTile>
                </div>
              )}
            </Fragment>
          );
        },
      )}
    </div>
  );
}
